import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { FirmwareDetails } from '../types/firmware-details';
import { FirmwareRoute } from '../types/firmware-route';

@Component({
  selector: 'firmware-route-edit',
  template: `<div class="editrow">
  <mat-form-field>
    <input #comment placeholder="A comment or description of this firmware route"
            matInput [(ngModel)]="route.comment" (ngModelChange)="changed()">
  </mat-form-field>
  <mat-checkbox #force labelPosition="after" class="boolean"
                [(ngModel)]="route.force" (ngModelChange)="changed()">force update</mat-checkbox>
</div>
<div class="editrow">
  <mat-form-field class="ip">
    <input #ip placeholder="An IP/subnet to get this upgrade" matInput [(ngModel)]="route.ip" (ngModelChange)="changed()" />
  </mat-form-field>
  <mat-form-field class="version">
    <mat-select #firmware placeholder="A firmware to get this upgrade" [(ngModel)]="+route.firmwareid" (ngModelChange)="changed()">
      <mat-option [value]="0">No firmware selected</mat-option>
      <mat-option *ngFor="let firmware of firmwares" [value]="firmware.uid">
        {{firmware.major}}.{{firmware.minor}}.{{firmware.patch}}<ng-container *ngIf="firmware.name"> - {{firmware.name}}</ng-container>
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field class="number">
    <input #hubid placeholder="Hub ID to get this upgrade"
         matInput [(ngModel)]="route.hubid" (ngModelChange)="changed()">
  </mat-form-field>
</div>
<div class="editrow">
  <div class="panel">
    <button mat-raised-button (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="save()" [disabled]="!hasChanges || !isValid()">Save</button>
  </div>
</div>
<div class="editrow">
  <p class="error" *ngFor="let error of errorMessages">{{error}}</p>
</div>
`,
  styles: [
    `.panel {display: inline-block; position: relative; bottom: 0.5em; left: 0.5em;}`,
    `.editrow {vertical-align: middle; display: block;}`,
    `.boolean {padding-left: 1em;}`,
    `.number {width: 7em; margin-left: 2em; text-align: right;}`,
    `.ip {width: 10em;}`,
    `.version { width: 15em; margin-left: 2em; }`,
    `p.error { color: #800000; padding: 0.1em 1em; margin: 0; white-space: pre-line; }`,
  ],
  providers: [ HubService ],
})

export class FirmwareRouteEditComponent implements OnInit {
  @Input() inRoute: FirmwareRoute;
  @Input() firmwares: FirmwareDetails[];
  @Output() routeSaved = new EventEmitter<boolean>();
  route: FirmwareRoute;
  hasChanges = false;
  errorMessages: string[];

  constructor(
    private hubService: HubService,
  ) {
  }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    if (!this.inRoute) { this.inRoute = new FirmwareRoute(); }
    this.route = Object.assign({}, this.inRoute);  // Clone
  }

  isValid(): boolean {
    this.errorMessages = <string[]>[];
    if (this.hasChanges) {
      if ((this.route.ip && this.route.hubid)
        || (this.route.firmwareid && this.route.hubid)
        || (this.route.ip && this.route.firmwareid)) {
        this.errorMessages.push('Only one of IP, Hub ID or Firmware ID may be set');
        return false;
      }
      if (!this.route.ip && !this.route.hubid && !this.route.firmwareid) {
        this.errorMessages.push('One of IP, Hub ID or Firmware ID must be set');
        return false;
      }
    }
    return true;
  }

  changed() {
    this.hasChanges = true;
  }

  cancel(): void {
    this.routeSaved.emit(false);
  }

  save(): void {
    if (!this.route.ip) {
      this.route.ip = undefined;
    }
    if (!this.route.hubid) {
      this.route.hubid = undefined;
    } else {
      this.route.hubid = +this.route.hubid;
    }
    if (!this.route.firmwareid) {
      this.route.firmwareid = undefined;
    } else {
      this.route.firmwareid = +this.route.firmwareid;
    }

    this.hubService.updateFirmwareRoute(this.route)
      .subscribe(
        () => {
          this.inRoute = this.route;
          this.routeSaved.emit(true);
          this.hasChanges = false;
        },
        (e: any) => this.errorMessages.push(e as string)
      );
  }
}
